<script>
  export let value = "";
  export let placeholder = "";
  export let type = "text";
  export let label;
  export let compact = false;
  export let disabled = false;
</script>

<div class="form-item" class:compact>
  {#if label}
    <h3>{label}</h3>
  {/if}
  {#if type === "password"}
    <input
      {disabled}
      bind:value
      type="password"
      {placeholder}
      on:input
      on:change
      on:focus
      on:keyup
    />
  {:else}
    <input
      {disabled}
      bind:value
      type="text"
      {placeholder}
      on:input
      on:change
      on:focus
      on:keyup
    />
  {/if}
</div>

<style>
  .form-item {
    margin: 24px 0;
  }

  .form-item.compact {
    margin: 0;
  }

  @media only screen and (min-width: 600px) {
    .form-item {
      min-width: 350px;
    }
  }

  .form-item input {
    border-radius: 0;
    width: 100%;
    margin-top: 1rem;
    border: 2px solid #eee;
    background-color: #eee;
    padding: 10px;
    transition: border 0.3s ease-in-out;
    border-bottom: 2px solid #999;
  }

  .form-item.compact input {
    margin: 0;
  }

  .form-item input:focus {
    border: 2px solid black;
    background-color: #f6f6f6;
    outline: none;
  }

  .form-item h3 {
    text-transform: uppercase;
    margin: 0;
    font-weight: 400;
    letter-spacing: 0.08rem;
    font-size: 14px;
  }
</style>
